export default "__VITE_ASSET__f297652c__"